import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import {GenericPaginatorState, PageSizes} from '../../index';
import {NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {NgPagination} from "./ng-pagination/ng-pagination.component";

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    TranslateModule,
    FormsModule,
    NgForOf,
    NgPagination,
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class PaginatorComponent implements OnDestroy {

  @Input({required: true}) paginatorState: GenericPaginatorState;
  @Input({transform: booleanAttribute}) showLoading: boolean = true;
  @Input({transform: booleanAttribute}) showPageSize: boolean = true;
  @Input({transform: booleanAttribute}) showPages: boolean = true;
  @Input({transform: booleanAttribute}) showPageInfo: boolean = true;
  @Input() isLoading: any;
  @Output() paginateChange: EventEmitter<GenericPaginatorState> = new EventEmitter();


  pageChange(num: number) {
    this.paginatorState.page = num;
    this.paginateChange.emit(this.paginatorState);
  }

  sizeChange() {
    this.paginatorState.itemsPerPage = Number(this.paginatorState.itemsPerPage);
    this.paginatorState.page = 1;
    this.paginateChange.emit(this.paginatorState);
  }

  ngOnDestroy(): void {
    this.paginatorState.itemsPerPage = PageSizes[2];
  }
}
